import React from 'react';
import { useHistory, useLocation, useRouteMatch, Route } from 'react-router-dom';
import isArray from 'lodash/isArray';
import { FadeSwitch } from '../components/switches';

const useTabsRouting = (options) => {
  const history = useHistory();
  const location = useLocation();
  const { path: routePath } = useRouteMatch();

  const filteredOptions = options.filter(
    ({ show, disabled }) => show && !disabled,
  );

  const routeLocation = location.pathname === routePath
    ? { ...location, pathname: `${routePath}/${filteredOptions[0].path}` }
    : location;

  const handleBack = () => history.goBack();

  const renderRoutes = () => (
    <FadeSwitch depth={3} customLocation={routeLocation}>
      {filteredOptions.map(({ id, label, path, component }) => {
        if (isArray(component)) {
          return component.map(
            ({
              id: subId,
              label: subLabel,
              path: subPath,
              component: subComponent,
            }) => (
              <Route
                id={subId}
                key={subLabel}
                path={`${routePath}/${path}/${subPath}`}
              >
                {subComponent}
              </Route>
            ),
          );
        }
        return (
          <Route id={id} key={label} path={`${routePath}/${path}`}>
            {component}
          </Route>
        );
      })}
    </FadeSwitch>
  );

  return {
    filteredOptions,
    routeLocation,
    handleBack,
    renderRoutes,
  };
};

export default useTabsRouting;
